<template>
  <div id="app">
    <header>
      <Header></Header>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer>
      <Footer></Footer>
    </footer>
  </div>
</template>

<script>
import Header from './components/common/Header.vue'
import Footer from './components/common/Footer.vue'
export default {
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
  @import 'src/styles/app.scss';
  #app {
    margin-top: 60px;
  }
</style>
